/* ================================================================
   GSAP FAILSAFE  (aggiunto — 1 solo blocco, nulla d'altro cambiato)
   ----------------------------------------------------------------
   PERCHÉ: se la CDN di GSAP non carica (rete lenta / dominio bloccato
   / anteprima Shopify), 'gsap' è undefined e la riga qui sotto
   "gsap.registerPlugin(ScrollTrigger)" lanciava un ReferenceError che
   INTERROMPEVA TUTTO lo script. Il loader a tutto schermo (z-index
   1000, sfondo #080B08) è nascosto SOLO da questo file → restava per
   sempre = schermata nera. Anche l'overlay del menu si apre solo via
   gsap.to(), quindi restava chiuso/nero.
   COSA FA: se GSAP è presente, questo blocco è INERTE (non fa nulla).
   Se GSAP manca, installa uno "shim" che applica gli stati finali
   senza animazione: loader nascosto, overlay aperto, testo visibile.
   (Il giorno in cui self-hosti GSAP puoi anche rimuoverlo.)
   ================================================================ */
(function () {
  function px(v){ return typeof v === 'number' ? v + 'px' : v; }
  function toEls(t){
    if (typeof t === 'string') return [].slice.call(document.querySelectorAll(t));
    if (t && t.nodeType) return [t];
    if (t && t.length != null) return [].slice.call(t);
    return [];
  }
  function apply(t, v){
    v = v || {};
    toEls(t).forEach(function(el){
      if (!el || !el.style) return;
      var tr = [];
      if (typeof v.x==='number'||typeof v.x==='string'||typeof v.y==='number'||typeof v.y==='string')
        tr.push('translate('+px(v.x||0)+','+px(v.y||0)+')');
      if ('xPercent' in v || 'yPercent' in v)
        tr.push('translate('+(v.xPercent||0)+'%,'+(v.yPercent||0)+'%)');
      if (typeof v.scale === 'number') tr.push('scale('+v.scale+')');
      if (tr.length) el.style.transform = tr.join(' ');
      if ('opacity' in v) el.style.opacity = v.opacity;
      if ('autoAlpha' in v){ el.style.opacity=v.autoAlpha; el.style.visibility = Number(v.autoAlpha)===0?'hidden':'visible'; }
      if (typeof v.clipPath==='string'){ el.style.clipPath=v.clipPath; el.style.webkitClipPath=v.clipPath; }
      if ('width' in v) el.style.width = px(v.width);
      if ('height' in v) el.style.height = px(v.height);
      if ('backgroundColor' in v) el.style.backgroundColor = v.backgroundColor;
      if ('borderWidth' in v) el.style.borderWidth = px(v.borderWidth);
    });
    if (typeof v.onComplete === 'function'){ try { v.onComplete(); } catch(e){} }
  }
  if (typeof window.ScrollTrigger === 'undefined')
    window.ScrollTrigger = { refresh:function(){}, update:function(){}, getAll:function(){return[];} };
  if (typeof window.gsap === 'undefined'){
    var chain = {
      to:function(t,v){ apply(t,v); return this; },
      from:function(t,v){ if(v&&typeof v.onComplete==='function'){try{v.onComplete();}catch(e){}} return this; },
      fromTo:function(t,a,b){ apply(t,b); return this; },
      set:function(t,v){ apply(t,v); return this; },
      add:function(){ return this; }
    };
    window.gsap = {
      registerPlugin:function(){},
      to:function(t,v){ apply(t,v); return chain; },
      from:function(t,v){ if(v&&typeof v.onComplete==='function'){try{v.onComplete();}catch(e){}} return chain; },
      fromTo:function(t,a,b){ apply(t,b); return chain; },
      set:function(t,v){ apply(t,v); return chain; },
      timeline:function(){ return chain; },
      ticker:{ add:function(){}, lagSmoothing:function(){}, remove:function(){} },
      utils:{ toArray: toEls }
    };
  }
})();


/* ============================================================
   Tenuta Grieci — theme.js (versione blindata + PULITA)
   - Il .loader a tutto schermo viene SEMPRE rimosso (3 vie: uscita
     normale ~2.7s, safety 6.2s, failsafe assoluto 7s). Mai schermo nero.
   - Fallback anti-GSAP: gestito UNICAMENTE dallo shim in cima al file.
     (Rimosso il vecchio ramo "if gsap undefined -> return": era codice
      morto, perché lo shim definisce sempre gsap/ScrollTrigger.)
   - sessionStorage e build() protetti da try/catch.
   ============================================================ */
(function(){
  function __tgKillLoader(){
    var el = document.querySelector('.loader');
    if (el) { el.style.display = 'none'; }
    var hidden = document.querySelectorAll('img.img-hide');
    for (var i = 0; i < hidden.length; i++){ hidden[i].classList.remove('img-hide'); }
  }
  /* FAILSAFE assoluto: qualunque cosa accada sotto, dopo 7s niente schermo nero. */
  setTimeout(__tgKillLoader, 7000);

  /* Controller loader — INDIPENDENTE da GSAP.
     La sequenza (goccia · onde · ulivo · wordmark) è CSS pura: parte aggiungendo
     .play e dura ~2.7s su un timer, NON sul caricamento pagina. L'uscita è una
     transizione CSS, così si anima anche se GSAP/CDN non si carica.
     Mostrato una volta a sessione; forzabile con ?loader nell'URL (per test).
     onExit() (es. build della scena) viene chiamato all'inizio dell'uscita. */
  function __tgNow(){ return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function __tgRunLoader(onExit){
    var el = document.querySelector('.loader');
    if (!el) { if (onExit) onExit(); return; }
    /* Loader mostrato a OGNI apertura pagina. Le animazioni della sequenza
       (.tg-loader__drop / __ring / __leaf / __word / __rule) sono CSS e partono
       da sole al render. Questo controller deve solo: mostrarlo, poi sfumarlo.
       Rimosso il gate once-per-session e la vecchia logica .tg-stage/.play. */
    var MIN = 2700, start = __tgNow(), gone = false;
    function exit(){
      if (gone) return; gone = true;
      if (onExit) onExit();                            /* il sito si anima mentre il loader sfuma */
      el.style.willChange = 'opacity,transform';
      el.style.transition = 'opacity 1.15s cubic-bezier(.16,1,.3,1),transform 1.35s cubic-bezier(.16,1,.3,1)';
      el.style.opacity = '0';
      el.style.transform = 'scale(1.06)';
      el.style.pointerEvents = 'none';
      setTimeout(function(){ el.style.display = 'none'; }, 1300);
    }
    function schedule(){ setTimeout(exit, Math.max(0, MIN - (__tgNow() - start))); }
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once:true });
    setTimeout(exit, 6200);                            /* safety: mai bloccato */
  }


gsap.registerPlugin(ScrollTrigger);
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const isMobile=matchMedia('(max-width:950px)').matches;
if(!reduce&&typeof Lenis!=='undefined'){const lenis=new Lenis({lerp:0.085,wheelMultiplier:0.9});lenis.on('scroll',ScrollTrigger.update);gsap.ticker.add((t)=>lenis.raf(t*1000));gsap.ticker.lagSmoothing(0);window.__lenis=lenis;}

/* ===== hero video: ensure autoplay (muted) + respect reduced motion ===== */
(function(){
  var v=document.querySelector('.hero__video video');if(!v)return;
  if(reduce){v.removeAttribute('autoplay');v.pause();return;}
  var tryPlay=function(){var p=v.play();if(p&&p.catch)p.catch(function(){});};
  tryPlay();
  /* alcuni browser bloccano finché non c'è interazione: ritenta al primo gesto */
  ['click','touchstart','keydown','wheel'].forEach(function(ev){
    window.addEventListener(ev,tryPlay,{once:true,passive:true});
  });
})();

/* ===== two-finger horizontal trackpad scroll → drives the horizontal scene =====
   Il trackpad orizzontale produce deltaX; lo convertiamo in scroll verticale
   così alimenta lo stesso pin/scrub della scena. Attivo solo su desktop. */
(function(){
  if(reduce)return;
  if(matchMedia('(max-width:950px)').matches)return;
  window.addEventListener('wheel',function(e){
    /* gesto orizzontale dominante: due dita laterali sul trackpad */
    if(Math.abs(e.deltaX)>Math.abs(e.deltaY)&&Math.abs(e.deltaX)>0){
      e.preventDefault();
      var dy=e.deltaX;
      if(window.__lenis){
        /* incremento immediato: i gesti rapidi non accodano animazioni in conflitto */
        window.__lenis.scrollTo(window.__lenis.scroll+dy,{immediate:true});
      }else{
        window.scrollBy(0,dy);
      }
    }
  },{passive:false});
})();

/* loader — sequenza cinematica Concept 1; all'uscita costruisce la scena. */
__tgRunLoader(build);

/* helpers */
function wrapLineChars(el){const t=el.textContent;el.textContent='';[].forEach.call(t,function(ch){var s=document.createElement('span');s.className='c';s.style.display='inline-block';s.textContent=ch===' '?'\u00A0':ch;el.appendChild(s);});}
function splitWords(el){const t=el.textContent.trim();el.innerHTML='';t.split(/(\s+)/).forEach(function(w){if(/^\s+$/.test(w)){el.appendChild(document.createTextNode(' '));return;}var s=document.createElement('span');s.className='wd';s.style.display='inline-block';s.style.overflow='hidden';var i=document.createElement('span');i.style.display='inline-block';i.textContent=w;s.appendChild(i);el.appendChild(s);});}

function build(){ try{
  const track=document.getElementById('track'),scene=document.getElementById('scene');
  /* Shopify: la scena orizzontale esiste solo nella homepage (sezione story-scene).
     Su product/collection/page non c'è → esci senza errori. */
  if(!track||!scene){ if(window.ScrollTrigger){ScrollTrigger.refresh();} return; }
  let scrollTween=null;
  if(!isMobile){
    scrollTween=gsap.to(track,{x:()=>-(track.scrollWidth-window.innerWidth),ease:'none',
      scrollTrigger:{trigger:scene,start:'top top',pin:true,scrub:1,invalidateOnRefresh:true,
        end:()=>'+='+(track.scrollWidth-window.innerWidth),
        onUpdate:(self)=>{document.getElementById('hbar').style.transform='scaleX('+self.progress+')';}}});
  }
  const cAnim=scrollTween?{containerAnimation:scrollTween}:{};

  /* flipMedia reveal + zoom 1.4->1 */
  gsap.utils.toArray('[data-flip]').forEach(function(flip){
    const front=flip.querySelector('.flipMedia__media--front');const imgs=flip.querySelectorAll('img');
    gsap.set(imgs,{scale:1.4});
    gsap.fromTo(front,{clipPath:'inset(0% 0% 0% 0%)'},{clipPath:'inset(0% 0% 100% 0%)',ease:'none',scrollTrigger:Object.assign({trigger:flip,start:'left 74%',end:'right 36%',scrub:true},cAnim)});
    gsap.to(imgs,{scale:1,ease:'none',scrollTrigger:Object.assign({trigger:flip,start:'left 92%',end:'right 16%',scrub:true},cAnim)});
  });

  /* hero title char reveal + lead/cta */
  document.querySelectorAll('.hero h1 .ln').forEach(function(ln,i){wrapLineChars(ln);
    gsap.from(ln.querySelectorAll('.c'),{yPercent:115,duration:.9,stagger:.025,ease:'power3.out',delay:.2+i*.08});});
  gsap.from('.hero h1 .sub',{y:30,opacity:0,duration:1,ease:'power3.out',delay:.55});
  gsap.from('.hero__eyebrow, .hero__lead, .hero .cta-row, .hero__mark',{y:24,opacity:0,duration:1,stagger:.1,ease:'power3.out',delay:.5});

  /* section titles: word rise */
  gsap.utils.toArray('.copy h2, .edition__txt h2, .contact h2').forEach(function(h){splitWords(h);
    gsap.from(h.querySelectorAll('.wd>span'),{yPercent:110,duration:.8,stagger:.06,ease:'power3.out',scrollTrigger:Object.assign({trigger:h.closest('.panel'),start:isMobile?'top 80%':'left 62%'},cAnim)});});
  gsap.utils.toArray('.copy .eyebrow, .copy p, .copy .cta-row, .edition__txt .eyebrow, .edition__txt p, .edition__no, .contact .eyebrow, .contact p, .contact .cta-row, .contact__mail').forEach(function(elx){
    gsap.from(elx,{y:22,opacity:0,duration:.9,ease:'power3.out',scrollTrigger:Object.assign({trigger:elx.closest('.panel'),start:isMobile?'top 82%':'left 55%'},cAnim)});});

  /* edition frame grow */
  const ef=document.querySelector('.edition__frame');
  if(ef&&!isMobile)gsap.fromTo(ef,{scale:.84},{scale:1,ease:'power1.inOut',scrollTrigger:Object.assign({trigger:ef.closest('.panel'),start:'left 85%',end:'center center',scrub:true},cAnim)});

  /* table words */
  gsap.utils.toArray('.table-words span').forEach(function(s){
    gsap.from(s,{yPercent:40,opacity:0,duration:.8,ease:'power3.out',scrollTrigger:Object.assign({trigger:'.p-table',start:isMobile?'top 78%':'left 58%'},cAnim)});});
  gsap.from('.table-sign',{opacity:0,y:20,duration:1,ease:'power2.out',scrollTrigger:Object.assign({trigger:'.p-table',start:isMobile?'top 70%':'left 40%'},cAnim)});

  /* full-bleed subtle inner drift */
  if(!isMobile)gsap.utils.toArray('.p-full .flipMedia__media--back img').forEach(function(img){
    gsap.fromTo(img,{xPercent:0},{xPercent:-10,ease:'none',scrollTrigger:Object.assign({trigger:img.closest('.p-full'),start:'left right',end:'right left',scrub:true},cAnim)});});

  /* footer brand drift */
  if(!reduce)gsap.fromTo('.footer__brand',{xPercent:6},{xPercent:-14,ease:'none',scrollTrigger:{trigger:'.footer',start:'top bottom',end:'bottom top',scrub:true}});

  /* maison panel */
  gsap.utils.toArray('.maison__quote').forEach(function(q){splitWords(q);
    gsap.from(q.querySelectorAll('.wd>span'),{yPercent:110,duration:.8,stagger:.06,ease:'power3.out',scrollTrigger:Object.assign({trigger:q.closest('.panel'),start:isMobile?'top 80%':'left 62%'},cAnim)});});
  gsap.utils.toArray('.maison .eyebrow, .maison__body, .maison__rule').forEach(function(elx){
    gsap.from(elx,{y:22,opacity:0,duration:.9,ease:'power3.out',scrollTrigger:Object.assign({trigger:elx.closest('.panel'),start:isMobile?'top 82%':'left 55%'},cAnim)});});

  /* contact deco */
  gsap.from('.contact__deco',{opacity:0,y:16,duration:.9,ease:'power3.out',scrollTrigger:Object.assign({trigger:'.p-contact',start:isMobile?'top 82%':'left 50%'},cAnim)});

  /* footer sigillo */
  gsap.from('.footer__sigillo',{opacity:0,y:14,duration:1,ease:'power2.out',scrollTrigger:{trigger:'.footer',start:'top 85%'}});
  gsap.from('#purchase .purchase-media',{y:40,opacity:0,duration:1,ease:'power3.out',scrollTrigger:{trigger:'#purchase',start:'top 85%'}});
  gsap.from('#purchase .purchase-card > *',{y:22,opacity:0,duration:.8,stagger:.06,ease:'power3.out',scrollTrigger:{trigger:'#purchase',start:'top 80%'}});

  ScrollTrigger.refresh();

}catch(__e){ try{ if(window.ScrollTrigger) ScrollTrigger.refresh(); }catch(_){} console.warn('[Tenuta Grieci] build() ha lanciato, contenuto comunque visibile:', __e); }
}

/* ===== poetic estate weather + icon (Open-Meteo, no key) — Melito Irpino ===== */
(function(){
    var ICONS={sun:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4"/></svg>',partly:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="3.2"/><path d="M8 1.5v1.5M1.5 8h1.5M3.6 3.6l1 1M12.5 4.5l-1 1"/><path d="M17.5 19H8a4 4 0 0 1 .3-8 5 5 0 0 1 9.5 1.4A3.3 3.3 0 0 1 17.5 19Z"/></svg>',cloud:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 19H7a4.5 4.5 0 0 1 .4-9 5.5 5.5 0 0 1 10.5 1.6A3.6 3.6 0 0 1 17.5 19Z"/></svg>',rain:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 15H7a4.5 4.5 0 0 1 .4-9 5.5 5.5 0 0 1 10.5 1.6A3.6 3.6 0 0 1 17.5 15Z"/><path d="M8 19l-1 2M12 19l-1 2M16 19l-1 2"/></svg>',storm:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 14H7a4.5 4.5 0 0 1 .4-9 5.5 5.5 0 0 1 10.5 1.6A3.6 3.6 0 0 1 17.5 14Z"/><path d="M12 13l-2 4h3l-2 4"/></svg>',snow:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 14H7a4.5 4.5 0 0 1 .4-9 5.5 5.5 0 0 1 10.5 1.6A3.6 3.6 0 0 1 17.5 14Z"/><path d="M9 19h.01M12 20h.01M15 19h.01"/></svg>',fog:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 9h14M5 13h13M4 17h12"/></svg>',moon:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 14.8A8 8 0 1 1 9.2 3.5a6.3 6.3 0 0 0 11.3 11.3Z"/></svg>',moonCloud:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M16 3.6a4 4 0 1 0 4.4 6.1"/><path d="M17 19H7.5A3.5 3.5 0 0 1 8 12a4.5 4.5 0 0 1 8.6 1.1A3 3 0 0 1 17 19Z"/></svg>'};

  /* colore icona per tipo: oro=sole, grigio=nuvola, celeste=pioggia, bianco=neve, arancio=temporale, lilla=nebbia, luna=notte */
  var ICO_COLOR={sun:'#C9A84C',partly:'#C9A84C',cloud:'#8C8172',rain:'#7EB8C9',storm:'#C97B3A',snow:'#D8E8F0',fog:'#9B8FA8',moon:'#C7CBD4',moonCloud:'#A6ADBA'};

  function iconKey(c,day){var night=(day===0);if(c===0||c===1)return night?'moon':'sun';if(c===2)return night?'moonCloud':'partly';if(c===3)return'cloud';if(c===45||c===48)return'fog';if((c>=51&&c<=67)||(c>=80&&c<=82))return'rain';if((c>=71&&c<=77)||c===85||c===86)return'snow';if(c>=95)return'storm';return night?'moon':'partly';}
  function phrase(c,day){var night=(day===0);if(c===0||c===1)return night?'Clear night over the groves':'Dry summer light';if(c===2)return night?'Soft night over the estate':'Soft Mediterranean light';if(c===3)return'Veiled light over the groves';if(c===45||c===48)return night?'Mist settling on the hills':'Morning mist over the estate';if((c>=51&&c<=67)||(c>=80&&c<=82))return'Rain feeding the olive trees';if((c>=71&&c<=77)||c===85||c===86)return'Rare frost on the hills';if(c>=95)return'Summer storm over the valley';return night?'Night over the estate':'Light over the estate';}

  function render(t,c,day){
    var key=iconKey(c,day);
    var color=ICO_COLOR[key]||'#C9A84C';
    var el=document.getElementById('estateNow');
    if(!el)return;
    el.style.setProperty('--ico-color',color);
    var intro=el.dataset.intro||'Today at the estate';
    var place=el.dataset.place||'Melito Irpino';
    el.innerHTML=intro+' \u00b7 <b>'+place+'</b> \u00b7 '+Math.round(t)+'\u00b0 <span class="w-ico">'+ICONS[key]+'</span> '+phrase(c,day);
  }

  var elN=document.getElementById('estateNow');
  var LAT=(elN&&elN.dataset.lat)||'41.135';
  var LNG=(elN&&elN.dataset.lng)||'15.066';
  var DEF_T=(elN&&parseFloat(elN.dataset.temp))||31;
  var __h=new Date().getHours();
  var DAY_GUESS=(__h>=7&&__h<20)?1:0;              /* stima giorno/notte prima della fetch */
  render(DEF_T,DAY_GUESS?0:3,DAY_GUESS);           /* default coerente con l'ora locale */
  (async()=>{try{const r=await fetch('https://api.open-meteo.com/v1/forecast?latitude='+LAT+'&longitude='+LNG+'&current=temperature_2m,weather_code,is_day&timezone=Europe%2FRome');if(!r.ok)throw 0;const d=await r.json();render(d.current.temperature_2m,d.current.weather_code,d.current.is_day);}catch(e){}})();
})();

/* ===== FlowingMenu (restrained, images = estate photos) =====
   Shopify: le voci arrivano dal blocco "menu-data" iniettato dalla sezione header
   (modificabili dal Theme Editor). Fallback: array vuoto → nessun errore. */
const MENU_ITEMS=(function(){
  try{
    var el=document.getElementById('menu-data');
    if(el){ var arr=JSON.parse(el.textContent||el.innerHTML); if(Array.isArray(arr)&&arr.length) return arr; }
  }catch(e){}
  /* Fallback JS: se #menu-data è vuoto/assente/non valido, il menu ha COMUNQUE le voci.
     Rende il menu indipendente da header.liquid: non può più uscire nero e vuoto. */
  return [
    {link:'#maison',text:'Maison',image:null},
    {link:'#estate',text:'Estate',image:null},
    {link:'#harvest',text:'Harvest',image:null},
    {link:'#harvest2026',text:'Harvest 2026',image:null},
    {link:'#edition',text:'Limited Edition',image:null},
    {link:'#gift',text:'Gifting',image:null},
    {link:'#table',text:'The Table',image:null},
    {link:'#request',text:'Private Request',image:null},
    {link:'#purchase',text:'First Harvest',image:null}
  ];
})();
const SPEED=18,animationDefaults={duration:0.6,ease:'expo'};
const distMetric=(x,y,x2,y2)=>{const a=x-x2,b=y-y2;return a*a+b*b;};
const findClosestEdge=(mx,my,w,hh)=>distMetric(mx,my,w/2,0)<distMetric(mx,my,w/2,hh)?'top':'bottom';
(function buildMenu(){const nav=document.getElementById('flowingMenu');if(!nav)return;nav.innerHTML='';
  MENU_ITEMS.forEach(function(item){
    const el=document.createElement('div');el.className='menu__item';
    el.innerHTML='<a class="menu__item-link" href="'+item.link+'">'+item.text+'</a><div class="marquee"><div class="marquee__inner-wrap"><div class="marquee__inner" aria-hidden="true"></div></div></div>';
    const inner=el.querySelector('.marquee__inner');
    for(let i=0;i<6;i++){const part=document.createElement('div');part.className='marquee__part';var __bg=item.image?'url('+item.image+'),var(--placeholder)':'var(--placeholder)';part.innerHTML='<span>'+item.text+'</span><div class="marquee__img" style="background-image:'+__bg+'"></div>';inner.appendChild(part);}
    nav.appendChild(el);
    let loop=null;const startLoop=()=>{const part=inner.querySelector('.marquee__part');if(!part)return;const w=part.offsetWidth;if(!w)return;if(loop)loop.kill();gsap.set(inner,{x:0});loop=gsap.to(inner,{x:-w,duration:SPEED,ease:'none',repeat:-1});};
    setTimeout(startLoop,60);window.addEventListener('resize',()=>setTimeout(startLoop,60));
    const marquee=el.querySelector('.marquee'),link=el.querySelector('.menu__item-link');
    link.addEventListener('mouseenter',function(ev){const r=el.getBoundingClientRect();const edge=findClosestEdge(ev.clientX-r.left,ev.clientY-r.top,r.width,r.height);gsap.timeline({defaults:animationDefaults}).set(marquee,{y:edge==='top'?'-101%':'101%'},0).set(inner,{yPercent:0},0).to(marquee,{y:'0%'},0);});
    link.addEventListener('mouseleave',function(ev){const r=el.getBoundingClientRect();const edge=findClosestEdge(ev.clientX-r.left,ev.clientY-r.top,r.width,r.height);gsap.timeline({defaults:animationDefaults}).to(marquee,{y:edge==='top'?'-101%':'101%'},0);});
  });
})();

/* ===== menu open/close ===== */
(function(){const toggle=document.getElementById('menuToggle'),overlay=document.getElementById('menuOverlay');if(!toggle||!overlay)return;let open=false;
  function openMenu(){open=true;document.body.classList.add('menu-open');toggle.setAttribute('aria-expanded','true');gsap.to(overlay,{clipPath:'inset(0 0 0% 0)',duration:.85,ease:'expo.inOut'});gsap.fromTo('.menu__item-link',{y:40,opacity:0},{y:0,opacity:1,duration:.6,stagger:.06,ease:'expo.out',delay:.28});}
  function closeMenu(){open=false;document.body.classList.remove('menu-open');toggle.setAttribute('aria-expanded','false');gsap.to(overlay,{clipPath:'inset(0 0 100% 0)',duration:.7,ease:'expo.inOut'});}
  toggle.addEventListener('click',function(){open?closeMenu():openMenu();});
  overlay.querySelectorAll('.menu__item-link').forEach(function(a){a.addEventListener('click',closeMenu);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&open)closeMenu();});
})();

/* ===== cursor ===== */
(function(){if(reduce||matchMedia('(hover:none),(pointer:coarse)').matches)return;
  var cur=document.getElementById('cursor'),sp=cur.querySelector('span'),x=innerWidth/2,y=innerHeight/2,tx=x,ty=y,vis=false;
  addEventListener('mousemove',function(e){tx=e.clientX;ty=e.clientY;if(!vis){cur.classList.add('show');vis=true;}
    /* sopra la lente FluidGlass: nascondi il cursore custom (la lente È il cursore) */
    if(e.target.closest('.harvest26__glass')&&document.body.classList.contains('webgl-lens')){
      gsap.to(cur,{opacity:0,duration:.2});return;
    } else if(cur.style.opacity!=='1'){gsap.to(cur,{opacity:1,duration:.2});}
    var buy=e.target.closest('[data-buy]');
    var ex=buy||e.target.closest('[data-explore]');
    if(ex){
      sp.textContent=buy?'Buy':'Discover';
      var tint=buy?'rgba(58,22,18,0.18)':'rgba(185,150,83,0.12)';
      gsap.to(cur,{width:78,height:78,backgroundColor:tint,borderWidth:1,duration:.45,ease:'power3.out'});
      cur.style.border='1px solid '+(buy?'var(--deep-wine)':'var(--gold)');
      gsap.to(sp,{opacity:1,duration:.25});
    }else{gsap.to(cur,{width:6,height:6,backgroundColor:'#B99653',duration:.45,ease:'power3.out'});cur.style.border='0';gsap.to(sp,{opacity:0,duration:.2});}});
  /* click su immagine bottiglia/edizione → vai diretto all'acquisto */
  addEventListener('click',function(e){
    var buy=e.target.closest('[data-buy]');
    if(buy){
      var dest=document.getElementById('purchase');
      if(dest){
        if(window.__lenis&&typeof window.__lenis.scrollTo==='function')window.__lenis.scrollTo(dest,{offset:-40,duration:1.1});
        else dest.scrollIntoView({behavior:'smooth'});
      }
    }
  });
  (function loop(){x+=(tx-x)*.2;y+=(ty-y)*.2;cur.style.transform='translate('+x+'px,'+y+'px) translate(-50%,-50%)';requestAnimationFrame(loop);})();})();

/* ===== Magnet — pull on Request CTAs (port vanilla of React Bits Magnet) ===== */
(function(){
  if(reduce||matchMedia('(hover:none),(pointer:coarse)').matches)return;
  var P=110,STRENGTH=4;
  var EXTRA='background .5s var(--ease),color .5s var(--ease),border-color .5s';
  var ACTIVE='transform .3s ease-out,'+EXTRA, INACTIVE='transform .5s ease-in-out,'+EXTRA;
  [].forEach.call(document.querySelectorAll('[data-magnet]'),function(el){
    var px=0,py=0;el.style.willChange='transform';el.style.transition=INACTIVE;
    window.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect();
      var cx=r.left+r.width/2-px, cy=r.top+r.height/2-py;
      var dx=Math.abs(cx-e.clientX), dy=Math.abs(cy-e.clientY);
      if(dx<r.width/2+P && dy<r.height/2+P){el.style.transition=ACTIVE;px=(e.clientX-cx)/STRENGTH;py=(e.clientY-cy)/STRENGTH;}
      else{el.style.transition=INACTIVE;px=0;py=0;}
      el.style.transform='translate3d('+px+'px,'+py+'px,0)';
    },{passive:true});
  });
})();

/* ===== DotGrid — hero dynamic ground (olive → gold), no InertiaPlugin ===== */
(function(){
  var wrap=document.getElementById('dotgrid');if(!wrap)return;
  var canvas=wrap.querySelector('canvas'),ctx=canvas.getContext('2d');
  var rd=matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* proximity = raggio d'influenza · pushMax = spostamento massimo (px) vicino al cursore
     follow = quanto i punti rincorrono il target (più alto = più reattivo)
     shock* = onda d'urto al click */
  var O={dotSize:4,gap:32,baseColor:'#1b241d',activeColor:'#B99653',
         proximity:200,pushMax:24,follow:0.16,
         shockRadius:340,shockStrength:46,idleAmp:1.1};
  function hexToRgb(x){var m=x.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);return m?{r:parseInt(m[1],16),g:parseInt(m[2],16),b:parseInt(m[3],16)}:{r:0,g:0,b:0};}
  var base=hexToRgb(O.baseColor),act=hexToRgb(O.activeColor),prox=O.proximity,proxSq=prox*prox;
  /* cursore: posizione reale (px,py) + posizione smussata (sxp,syp) per un campo fluido */
  var dots=[],circle,dpr,pr={x:-9999,y:-9999,sxp:-9999,syp:-9999,active:false},t0=performance.now();
  function buildG(){var r=wrap.getBoundingClientRect(),w=r.width,hh=r.height;if(!w||!hh)return;dpr=window.devicePixelRatio||1;
    canvas.width=w*dpr;canvas.height=hh*dpr;canvas.style.width=w+'px';canvas.style.height=hh+'px';ctx.setTransform(dpr,0,0,dpr,0,0);
    var cell=O.dotSize+O.gap,cols=Math.floor((w+O.gap)/cell),rows=Math.floor((hh+O.gap)/cell);
    var gw=cell*cols-O.gap,gh=cell*rows-O.gap,sx=(w-gw)/2+O.dotSize/2,sy=(hh-gh)/2+O.dotSize/2;
    dots=[];for(var y=0;y<rows;y++)for(var x=0;x<cols;x++)dots.push({cx:sx+x*cell,cy:sy+y*cell,ox:0,oy:0,sx:0,sy:0});
    circle=new Path2D();circle.arc(0,0,O.dotSize/2,0,Math.PI*2);}
  function draw(){if(circle){ctx.clearRect(0,0,canvas.width,canvas.height);var tm=(performance.now()-t0)/1000;
    /* smussa la posizione del cursore: il "centro" del campo insegue dolcemente il mouse */
    if(pr.active){pr.sxp+=(pr.x-pr.sxp)*0.22;pr.syp+=(pr.y-pr.syp)*0.22;}
    var px=pr.sxp,py=pr.syp;
    for(var i=0;i<dots.length;i++){var d=dots[i];
      /* ── repulsione radiale continua ── */
      var tox=0,toy=0,fill='rgb('+base.r+','+base.g+','+base.b+')',sc=1;
      if(pr.active){var dx=d.cx-px,dy=d.cy-py,dsq=dx*dx+dy*dy;
        if(dsq<=proxSq){var dist=Math.sqrt(dsq)||0.0001;
          var t=1-dist/prox,tt=t*t*(3-2*t);          /* smoothstep: 1 al cursore → 0 al bordo */
          var nx=dx/dist,ny=dy/dist;                  /* direzione esattamente radiale */
          tox=nx*tt*O.pushMax;toy=ny*tt*O.pushMax;    /* spostamento ∝ intensità (cala con la distanza) */
          var rr=Math.round(base.r+(act.r-base.r)*tt),gg=Math.round(base.g+(act.g-base.g)*tt),bb=Math.round(base.b+(act.b-base.b)*tt);
          fill='rgb('+rr+','+gg+','+bb+')';sc=1+tt*0.7;
        }}
      /* molla: insegue il target di repulsione + ritorna a 0 quando il cursore si allontana */
      d.ox+=(tox-d.ox)*O.follow;d.oy+=(toy-d.oy)*O.follow;
      /* onda d'urto del click si smorza da sé */
      d.sx*=0.90;d.sy*=0.90;
      var idx=Math.sin(tm*0.9+d.cx*0.012+d.cy*0.006)*O.idleAmp,idy=Math.cos(tm*0.8+d.cy*0.012)*O.idleAmp;
      var rx=d.cx+d.ox+d.sx+idx,ry=d.cy+d.oy+d.sy+idy;
      ctx.save();ctx.translate(rx,ry);if(sc!==1)ctx.scale(sc,sc);ctx.fillStyle=fill;ctx.fill(circle);ctx.restore();}}
    requestAnimationFrame(draw);}
  function onMove(e){var rect=canvas.getBoundingClientRect();var nx=e.clientX-rect.left,ny=e.clientY-rect.top;
    if(!pr.active){pr.sxp=nx;pr.syp=ny;}      /* primo ingresso: niente scatto dal -9999 */
    pr.x=nx;pr.y=ny;pr.active=true;}
  function onLeave(){pr.active=false;}        /* i punti tornano a riposo via molla */
  function onClick(e){var rect=canvas.getBoundingClientRect(),cx=e.clientX-rect.left,cy=e.clientY-rect.top;
    for(var i=0;i<dots.length;i++){var d=dots[i],dx=d.cx-cx,dy=d.cy-cy,dist=Math.hypot(dx,dy);
      if(dist<O.shockRadius){var fo=1-dist/O.shockRadius,nx=dx/(dist||1),ny=dy/(dist||1);
        d.sx+=nx*O.shockStrength*fo*fo;d.sy+=ny*O.shockStrength*fo*fo;}}}
  buildG();
  if('ResizeObserver' in window)new ResizeObserver(buildG).observe(wrap);else addEventListener('resize',buildG);
  if(!rd){window.addEventListener('mousemove',onMove,{passive:true});window.addEventListener('mouseout',onLeave);window.addEventListener('click',onClick);}
  requestAnimationFrame(draw);
})();

})();